export default __webpack_public_path__ + "static/media/Prasad.eb884ffa.png";